
type StepId = "general" | "personal" | "verification"  | "review";

export const STEPS: { id: StepId; label: string }[] = [
  { id: "general", label: "Create" },
  { id: "personal", label: "Personal" },
  { id: "verification", label: "Verification" },
  { id: "review", label: "Review" },
] satisfies Array<{ id: StepId; label: string }>;

export const COUNTRY_OPTIONS = [
  {
    value: "US",
    label: "United States (USA)",
    iconUrl: "https://flagcdn.com/w40/us.png",
  },
  {
    value: "CA",
    label: "Canada (CAD)",
    iconUrl: "https://flagcdn.com/w40/ca.png",
  },
];